import { lazy, Suspense, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth.tsx";
import { Layout } from "./components/Layout.tsx";
import { Loading } from "./components/ui.tsx";
import { LoginPage } from "./pages/LoginPage.tsx";
import { recorder } from "./recording/recorder.ts";
import { uploader } from "./recording/uploader.ts";

const HomePage = lazy(() => import("./pages/HomePage.tsx"));
const NewVisitPage = lazy(() => import("./pages/NewVisitPage.tsx"));
const VisitsPage = lazy(() => import("./pages/VisitsPage.tsx"));
const VisitPage = lazy(() => import("./pages/VisitPage.tsx"));
const RecordPage = lazy(() => import("./pages/RecordPage.tsx"));
const PrintPage = lazy(() => import("./pages/PrintPage.tsx"));
const PatientsPage = lazy(() => import("./pages/PatientsPage.tsx"));
const PatientPage = lazy(() => import("./pages/PatientPage.tsx"));
const CodingPage = lazy(() => import("./pages/CodingPage.tsx"));
const ModulePage = lazy(() => import("./pages/ModulePage.tsx"));
const ProfilePage = lazy(() => import("./pages/ProfilePage.tsx"));
const JournalPage = lazy(() => import("./pages/JournalPage.tsx"));
const StatsPage = lazy(() => import("./pages/StatsPage.tsx"));
const AdminPage = lazy(() => import("./admin/AdminPage.tsx"));
const AisolPage = lazy(() => import("./aisol/AisolPage.tsx"));

export function App() {
  const { me, loading } = useAuth();

  useEffect(() => {
    if (me) {
      void recorder.restore(me.user.id);
      uploader.kick();
    }
  }, [me]);

  if (loading && !me) return <Loading text="Открываем платформу…" />;
  if (!me) return <LoginPage />;

  return (
    <Routes>
      <Route path="/visits/:id/print" element={<Suspense fallback={<Loading />}><PrintPage /></Suspense>} />
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/visits/new" element={<NewVisitPage />} />
        <Route path="/visits" element={<VisitsPage />} />
        <Route path="/visits/:id" element={<VisitPage />} />
        <Route path="/visits/:id/record" element={<RecordPage />} />
        <Route path="/patients" element={<PatientsPage />} />
        <Route path="/patients/:id" element={<PatientPage />} />
        <Route path="/coding" element={<CodingPage />} />
        <Route path="/modules/:id" element={<ModulePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
        <Route path="/aisol/*" element={<AisolPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
